module.exports = __webpack_public_path__ + "static/img/greenLogo.b9b7e8be.png";